export enum ImportType {
  LegacyImport = "LegacyImport",
  MetadataImport = "MetadataImport",
}
